import { useParams } from 'react-router'
import './index.less'
import { useContext, useEffect, useState } from 'react';
import { EngineContext, NavigationContext } from '@/App';
import { Section } from '@/declare/interface/project/section';
import { findSection } from '@/declare/api/system-lib/section';
import { message } from 'antd';
import { useLocation } from 'react-router';
import Draw from '../draw/draw';
import { PythaEventStructComData } from 'pytha2-structure';

/**
 * 截面详情页签
 * @returns 
 */
export default function SectionDetail() {
    const location = useLocation();

    const { projectUuid, sectionId } = useParams(); // 路由参数 项目uuid，截面id
    const navigateContext = useContext(NavigationContext); // 页签上下文
    const engineContext = useContext(EngineContext);    // 引擎上下文
    const [item, setItem] = useState<Section>(); // 截面信息
    const [selectedKey, setSelecetdKey] = useState<string>(); // 选中的信息页签，形状、几何、物理/力学

    useEffect(() => {
        if (!sectionId) return;
        generateData();
    }, [sectionId])

    useEffect(() => {
        if (item == null) return;
        // 触发事件
        const data: { [key: string]: any } = {};
        Object.keys(item).forEach(key => {
            data[key] = item[key];
        })
        data['paramIn'] = item.paramIn;
        data['sectionProtoType'] = item.type;
        const event = new PythaEventStructComData();
        event.data = data;
        if (engineContext.engine) {
            engineContext.emitCommand("GEN_SECTION_REGION");
            engineContext.engine?.eventMediator?.emitEvent(event);
        } else {
            setTimeout(() => {
                engineContext.emitCommand("GEN_SECTION_REGION");
                engineContext.engine?.eventMediator?.emitEvent(event);
            }, 3000);
        }
    }, [item])

    /**
     * 查询截面详情
     */
    const generateData = () => {
        findSection(sectionId, null).then(res => {
            let section: Section = res.data;
            setItem(section);
            navigateContext.registTab({
                key: location.pathname,
                value: section.name,
            })
            navigateContext.setActiveTabKey(location.pathname);
        }).catch(err => {
            message.error("获得截面详情失败");
        })
    }

    return (
        <div className="section-detail-container">
            <div className='section-detail-left'>
                <Draw />
            </div>
            <div className='section-detail-right'></div>
            <div className="right-btn-group">
                {/* <div>形状</div>
                <div>几何</div>
                <div>物理/力学</div> */}
            </div>
            <div className="param-content">
                {selectedKey == 'paramIn' && (
                    <>
                        <div className="group-title"><div className="title">参数</div></div>

                        <div className="row">
                            <div className="symbol"></div>
                        </div>
                        <div className="group-title"><div className="title">约束</div></div>
                    </>
                )}
                {selectedKey == 'paramOutGeo' && (
                    <>
                        <div className="group-title"></div>
                    </>
                )}
                {selectedKey == 'paramOutPh' && (
                    <>
                        <div className="group-title"></div>
                    </>
                )}

            </div>
        </div>
    )
}